/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form, Formik } from "formik";
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import { Label } from "components/Form";
import Colors from 'constants/Colors';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { useHistory } from 'react-router-dom';
import { ButtonContent, Title, AddButton, Text, BorderSwitch } from './styles';
import Loader from 'components/Loader';
import FormContainer from 'components/FormContainer';
import * as yup from 'yup';
import _ from 'lodash';
import { LostCancelButton } from 'components/index';
import { options } from 'numeral';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import Icon from 'components/Icon';
import { useHeaderNbi, useInsurerValues, useMrc1, useMrc2 } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';

// Novo formato imports
import { FormSection } from '@fitinsur/components';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer,
  useDeleteQuestionnaireAnswer
} from '@fitinsur/services/QuestionnaireAnswerService';
import { onValidationError, getQuestionIsDisabled, removeAnswersDuplicateSession } from './utils';
import { handleQuestionsInitialAdjustments, handleQuestionChange } from './handleQuestionChange';
import HasPermission from 'components/HasPermission/index';

export default function MrcComplementaryInformation(props) {
  const [lostDeal, setLostDeal] = useState({
    formated: [],
    array: [],
  });
  const [summary, setSummary] = useState({});
  const [isDisable, setIsDisable] = useState(false);
  const [formDisabled, setFormDisabled] = useState(true);
  const validationSchema = useRef(yup.object().shape({}));
  const [endorsementType, setEndorsementType] = useState("");
  const [questionnaire, setQuestionnaire] = useState([]);
  const [isMAS, setIsMAS] = useState(false);
  const [isNewYork, setIsNewYork] = useState(false);
  const [idProduct, setIdProduct] = useState(null);
  const [lloydsLeaders, setLloydsLeaders] = useState([]);
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const formikRef = useRef({});
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();


  // Novos states
  const [otherFeesGroup, setOtherFeesGroup] = useState([]);
  const [deductionsGroup, setDeductionsGroup] = useState([]);
  const [lossPayeeGroup, setLossPayeeGroup] = useState([]);
  const [isBound, setIsBound] = useState(false);
  const [feePayableByGroup, setFeePayableByGroup] = useState([]);

  const [showBrokerRemuneration, setShowBrokerRemuneration] = useState(false);
  const [showBrokerOther, setShowBrokerOther] = useState(false);
  const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
  const [isChecking, setIsChecking] = useState(false);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useInsurerValuesData,
    loading: useInsurerValuesLoading,
    error: useInsurerValuesError,
    status: useInsurerValuesStatus,
    request: useInsurerValuesRequest,
  } = useInsurerValues(props.match.params.idOperation);

  const {
    data: useMrc1Data,
    loading: useMrc1Loading,
    error: useMrc1Error,
    status: useMrc1Status,
    request: useMrc1Request,
  } = useMrc1(props.match.params.idOperation);

  const {
    data: useMrc2Data,
    loading: useMrc2Loading,
    error: useMrc2Error,
    status: useMrc2Status,
    request: useMrc2Request,
  } = useMrc2(props.match.params.idOperation);


  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    status: useDeleteQuestionnaireAnswerStatus,
    loading: useDeleteQuestionnaireAnswerLoading,
    request: useDeleteQuestionnaireAnswerRequest,
  } = useDeleteQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    if (useHeaderNbiLoading ||
      useOperationInfoLoading ||
      useInsurerValuesLoading ||
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useMrc1Loading ||
      useMrc2Loading ||
      useDeleteQuestionnaireAnswerLoading || 
      isChecking
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useHeaderNbiLoading,
    useOperationInfoLoading,
    useInsurerValuesLoading,
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useMrc1Loading,
    useMrc2Loading,
    useDeleteQuestionnaireAnswerLoading,
    isChecking
  ]);

  useEffect(() => {
    setFormDisabled(false);
    getOperationInfo();
    handleSummary();
  }, []);


  useEffect(() => {
    buildValidation();
  }, [questionnaire, feePayableByGroup, deductionsGroup, otherFeesGroup, showBrokerOther, showBrokerRemuneration, lossPayeeGroup]);


  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      if (props.match.params.idOperation && questionnaireAnswersToDelete.length) {
        useDeleteQuestionnaireAnswerRequest({ ids: questionnaireAnswersToDelete });
      } else {
        useGetQuestionnairesAnswersRequest();
        const questionnaireAnswers = useSaveQuestionnaireAnswerData.value?.questionnaireAnswers;
        if (questionnaireAnswers?.length) {
          generateMRCDocuments(questionnaireAnswers);
        }
      }
    }

    if (useSaveQuestionnaireAnswerStatus === 400) {
      useSaveQuestionnaireAnswerError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  useEffect(() => {
    if (useDeleteQuestionnaireAnswerStatus === 200) {
      useGetQuestionnairesAnswersRequest();
      const questionnaireAnswers = useSaveQuestionnaireAnswerData.value?.questionnaireAnswers;
      if (questionnaireAnswers?.length) {
        generateMRCDocuments(questionnaireAnswers);
      }
    }
  }, [useDeleteQuestionnaireAnswerStatus]);

  useEffect(() => {
  }, [questionnaireAnswersToDelete])



  const generateMRCDocuments = async (body) => {
    if (endorsementType == 'market-changes') {
      history.push(`/broking/risk-and-market-changes-edit/${props.match.params.idOperation}`);
      return;
    }

    fitinsur.setAuthToken(authContext.token);
    useMrc1Request(body).then(response => {
      if (response.status !== 200) {
        mc.error(response.ret_msg_details);
        setIsDisable(true);
        return;
      }

      setTimeout(() => {
        getStatusOperation()
      }, 3000);

      useMrc2Request(body).then(response => {
        if (response.status != 200) {
          mc.error(response.ret_msg_details);
          setIsDisable(true);
          return;
        }
      }).catch((error) => {
      });
    }).catch((error) => {
      mc.error("There was an error while saving your data (MRC1): \n" + error);
      loading.stop();
    });
  }

  const SECTIONS = {
    RISK_DETAILS: { name: 'RISK_DETAILS', isMultiple: false, isRisk: false },
    RISK_DETAILS_GROUP: { name: 'RISK_DETAILS_GROUP', isMultiple: true, isRisk: false },
    INFORMATION: { name: 'INFORMATION', isMultiple: false, isRisk: false },
    SECURITY_DETAILS: { name: 'SECURITY_DETAILS', isMultiple: false, isRisk: false },
    SUBSCRIPTON_AGREEMENT: { name: 'SUBSCRIPTON_AGREEMENT', isMultiple: false, isRisk: false },
    FISCAL_AND_REGULATORY: { name: 'FISCAL_AND_REGULATORY', isMultiple: false, isRisk: false },
    BROKER_REMUNERATION: { name: 'BROKER_REMUNERATION', isMultiple: true, isRisk: false },
    BROKER_REMUNERATION_DEDUCTION: { name: 'BROKER_REMUNERATION_DEDUCTION', isMultiple: true, isRisk: false },
    FEE_PAYABLE_BY: { name: 'FEE_PAYABLE_BY', isMultiple: true, isRisk: false },
    PARTYS: { name: 'PARTYS', isMultiple: false, isRisk: false },
    BROKER_REMUNERATION_FEE_CLIENT: { name: 'BROKER_REMUNERATION_FEE_CLIENT', isMultiple: false, isRisk: false },
    BROKER_REMUNERATION_OTHER: { name: 'BROKER_REMUNERATION_OTHER', isMultiple: false, isRisk: false },
    DECLARATION_TEMPLATE: { name: 'DECLARATION_TEMPLATE', isMultiple: false, isRisk: false }
  };


  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        currency: data.ret_value.currency,
        nmObligor: data.ret_value.nmObligor,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
      });
      setEndorsementType(data.ret_value.endorsmentType);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
      });
  };

  const handleMktCompostion = () => history.push(`/broking/market-composition/${props.match.params.idOperation}`)

  async function handlePolicyPack() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.createPolicyPack(props.match.params.idOperation)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          loading.stop();
          return;
        }
        loading.stop();
        history.push(`/broking/send-approval-pack-declaration/${props.match.params.idOperation}`);
      })
      .catch((error) => {
        loading.stop();
        mc.error(error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function getStatusOperation() {
    setIsChecking(true);
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGenerateMrcStatus(props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details || 'There was an error while processing your data, please try again');
          setIsChecking(false);
          return;
        }

        if (data.ret_value.errorMessage && data.ret_value.errorMessage.trim().length) {
          mc.error(data.ret_value.errorMessage || 'There was an error while processing your data, please try again')
          setIsChecking(false);
          return
        }

        if (data.ret_value.statusOperation === 'created') {
          if (endorsementType === "declaration") {
            fitinsur.requestGenerateWording(props.match.params.idOperation)
              .then(data => data.json())
              .then(resp => {
                if (resp.ret_code !== 200) {
                  mc.error(resp.ret_msg_details);
                  setIsChecking(false);
                  return;
                }
                handlePolicyPack();
              }).catch((error) => {
                mc.error("There was an error while saving your data Wording: \n" + error);
                setIsChecking(false);
              });
          } else {
            history.push(`/broking/send-mrc-request/${props.match.params.idOperation}`);
            return;
          }

          return;
        };

        setTimeout(() => {
          getStatusOperation();
        }, 3000);

      }).catch((error) => {
        setIsChecking(false);

        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  function getOperationInfo() {
    useOperationInfoRequest().then(({ data: response }) => {
      setIdProduct(response.idProduct);
      setIsNewYork(response.isNewYork);
      setIsMAS(response.isMas);
      setIsBound(response.isBound);
      getLloydsAndSlipLeaders();
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  function getLloydsAndSlipLeaders() {
    useInsurerValuesRequest().then(({ data: res }) => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        loading.stop();
        return;
      }

      setLloydsLeaders(res.ret_value.lloydsLeaders.listLloydsLeaders);

      useGetQuestionnairesAnswersRequest();
    })
  };

  const groupMultipleFieldQuestions = (mainIdQuestion, questionnaire, isBound) => {
    const groupQuestions = [];

    const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
    for (const mainQuestion of mainQuestions) {
      let group = []
      const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
      if (mainQuestionIndex || mainQuestionIndex == 0) group.push(questionnaire[mainQuestionIndex]);
      if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);
      if (mainQuestion && mainQuestion.childrenQuestions && mainQuestion.childrenQuestions.length > 0) {
        mainQuestion.childrenQuestions.map(childQuestion => {
          group.push(childQuestion)
        });
      }

      group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
      groupQuestions.push(group.map((question, index) => ({ ...question })));
    }

    return groupQuestions;
  }


  const handleQuestionnaire = async (data) => {
    let questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc
    ];

    if(idProduct !== 16) questionnaire = questionnaire.filter(question => question.idQuestion !== 166);    
    questionnaire = handleQuestionsInitialAdjustments(questionnaire, endorsementType);

    questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    const facilities = questionnaire.filter(question => question.idQuestion === 123);
    let indexFacility = 0;

    questionnaire = questionnaire.map(question => {
      if (question.idQuestion === 1466) {
        question.behaviorObject.sectionName = 'RISK_DETAILS_GROUP';
        question.behaviorObject.tabletWidth = 100;
        question.behaviorObject.mobileWidth = 100;
        question.behaviorObject.desktopWidth = 33.1;
      }

      if (question.idQuestion === 1443) question.visibleQuestion = (lloydsLeaders && lloydsLeaders.length > 1) ? true : false;

      if (question.idQuestion === 128) question.behaviorObject.sectionName = 'RISK_DETAILS';

      if (question.idQuestion === 171) {
        setShowBrokerRemuneration(question?.idAnswerOption && question?.idAnswerOption === 1166)
      }

      if (question.idQuestion === 128) {
        for (const [index, facility] of facilities.entries()) {
          if (index === indexFacility) {
            question.dsQuestion = `${question.dsQuestion} - ${facility.answer}`;
            indexFacility++;
            break;
          }
        }
      }

      if (question.idQuestion === 175) {
        setShowBrokerOther(question?.idAnswerOption && question?.idAnswerOption === 6893)
      }

      return question;
    });


    setOtherFeesGroup(groupMultipleFieldQuestions(1438, questionnaire, isBound))
    setDeductionsGroup(groupMultipleFieldQuestions(1444, questionnaire, isBound))
    setLossPayeeGroup(groupMultipleFieldQuestions(1466, questionnaire, isBound))

    const insurersGroup = groupMultipleFieldQuestions(1378, questionnaire, isBound);
    const feePayabeByGroupAux = groupMultipleFieldQuestions(1464, questionnaire, isBound);
    const hasAnswer = feePayabeByGroupAux[0]?.find(question => question.idQuestion === 1464)?.answer;
    let feePayabeByGroup = [];
    if (!hasAnswer) {
      try {
        const feeTypes = insurersGroup.map(group => {
          const feeType = group.find(question => question.idQuestion === 1380);
          if (feeType.answer) {
            const hasTax = feePayabeByGroup.find(group => group.find(question => question.idQuestion === 1464 && question.answer === feeType.answer));
            if (hasTax) return;

            const questionGroup = JSON.parse(JSON.stringify(feePayabeByGroupAux[0]));
            const feeTypePayable = questionGroup.find(question => question.idQuestion === 1464);
            feeTypePayable.answer = feeType.answer;
            feeTypePayable.answerJson = feeType.answerJson
            feeTypePayable.disabled = true;
            feePayabeByGroup.push(questionGroup)
          }
        })
      } catch (e) { }
    } else {
      insurersGroup.map(group => {
        const feeType = group.find(question => question.idQuestion === 1380);
        if (feeType.answer) {
          const hasTax = feePayabeByGroupAux.find(group => group.find(question => question.idQuestion === 1464 && question.answer === feeType.answer));
          const alreadyExistsTax = feePayabeByGroup.find(group => group.find(question => question.idQuestion === 1464 && question.answer === feeType.answer));
          
          if (!alreadyExistsTax) { 
            if (hasTax) { 
              feePayabeByGroup.push(hasTax);
            } else { 
              let questionGroup = JSON.parse(JSON.stringify(feePayabeByGroupAux[0]));
              questionGroup = questionGroup.map(tax => {
                if (tax.idQuestion == 1464) { 
                  tax.answer = feeType.answer;
                  tax.answerJson = feeType.answerJson;
                  tax.disabled = true;
                }
  
                if (tax.idQuestion == 1433) { 
                  tax.answer = "";
                  tax.answerJson = "";
                  tax.idAnswerOption = null;
                }
  
                tax.idQuestionnaireAnswers = null;
  
                return tax;
              });
              feePayabeByGroup.push(questionGroup);
            }  
          }
        }
      })

      let questionsToDelete = []; 
      feePayabeByGroupAux.map(group => {
        const feeType = group.find(question => question.idQuestion === 1464);
         if (feeType.answer) {
          const hasTax = insurersGroup.find(group => group.find(question => question.idQuestion === 1380 && question.answer === feeType.answer));
          if (!hasTax) { 
            group.map(tax => { 
              questionsToDelete.push(tax.idQuestionnaireAnswers || null);
            })
          };
        }
      })

      questionnaire.map(qst => {
        if (!qst.visibleQuestion && qst.answer && qst.idQuestionnaire == 18 && [1443].includes(qst.idQuestion)) { 
          questionsToDelete.push(qst.idQuestionnaireAnswers || null); 
        }
      })
      
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...questionsToDelete
      ])
    }

    feePayabeByGroup.map(taxRow => {
      taxRow = handleQuestionsInitialAdjustments(taxRow);
    })

    setFeePayableByGroup(feePayabeByGroup);

    setQuestionnaire(questionnaire);
  }

  const renderAddAndRemoveButtons = (array, index, questions, setFunction, partySectionName, values) => {
    return (
      <>
        {index !== 0 ?
          <AddButton style={{ alignItems: 'center' }} onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction(array.filter((v, i) => i !== index));
            setQuestionnaireAnswersToDelete([
              ...questionnaireAnswersToDelete,
              ...questions.map(
                question => question.idQuestionnaireAnswers
              ).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
            ])
          }}>
            <Icon name="trash" style={{ margin: 0 }} />
          </AddButton> : <></>}

        {index === array.length - 1 ?
          <AddButton style={{ alignItems: 'center' }} onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction([...array, handleQuestionsInitialAdjustments(removeAnswersDuplicateSession(questions))]);
          }}>
            <Icon name="plus" style={{ margin: 0 }} />
          </AddButton> : <></>}
      </>
    )
  }

  const buildValidation = () => {
    const validationSchema = {};

    const fieldErrorMessage = (question) => {
      formikRef.current.isSubmitting && mc.error(`The Field ${question.dsQuestion} is required`);
      return "* required field"
    };

    const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
    for (const question of questionnaire) {
      if (!question.key) continue;
      if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;

      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().required(() => fieldErrorMessage(question))
        : yup.string().notRequired();
    }

    return yup.object().shape(validationSchema);
  }


  const handleSaveQuestionnaireAnswer = (values, idOperation, onlyQuestions) => {
    const formValues = JSON.parse(JSON.stringify(values)) || {};

    const body = { questionnaireAnswers: [] };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          case 'BROKER_REMUNERATION':
            multipleFields = otherFeesGroup
            break;
          case 'BROKER_REMUNERATION_DEDUCTION':
            multipleFields = deductionsGroup;
            break;
          case 'RISK_DETAILS_GROUP':
            multipleFields = lossPayeeGroup;
            break;
          case 'FEE_PAYABLE_BY':
            multipleFields = feePayableByGroup;
            break;
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
          if (sectionAnswers?.length) {
            const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
            const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
            }
          }
        })
      } else {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
        if (sectionAnswers) {
          body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
        }
      }
    }

    let parsedSecondLloydsLeader;
    let parsedLloydsLeader;

    const lloydsLeader = body.questionnaireAnswers.find(question => question.idQuestion === 1437)?.answer;
    const secondLloydsLeader = body.questionnaireAnswers.find(question => question.idQuestion === 1443)?.answer;

    if (lloydsLeader) parsedLloydsLeader = JSON.parse(lloydsLeader) || {};
    if (secondLloydsLeader) parsedSecondLloydsLeader = JSON.parse(secondLloydsLeader) || {};

    for (const question of body.questionnaireAnswers) {
      if ((question.idDomainQuestion === 270 ||
        question.idDomainQuestion === 271 ||
        (question.idDomainQuestion === 44 && typeof question.answer === 'object')
      ) && question.answer) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    if (parsedLloydsLeader && parsedSecondLloydsLeader && parsedLloydsLeader?.id === parsedSecondLloydsLeader?.id) return mc.error(`The Second Lloyds Leader and the Lloyds Leader could not be the same`);

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }


  const hire = async (values) => {
    try {
      buildValidation().validate(values, { abortEarly: false })
        .then(() => {
          handleSaveQuestionnaireAnswer(values, props.match.params.idOperation);
        })
        .catch((e) => {
          onValidationError(e, mc, formikRef, questionnaire, [...otherFeesGroup, ...deductionsGroup, ...feePayableByGroup, ...lossPayeeGroup])
        })

    } catch (e) {
      mc.error(`There was an error while processing your data, please try again`);
      console.log("hire error", e);
    }
  }

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"} >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard title="GENERATE MRC" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <>
          <Formik
            innerRef={formikRef}
            initialValues={{}}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize={true}
            onSubmit={values => hire(values)}
            render={({ FormikProps, values, setFieldValue, setFieldError, errors }) => (
              <Form style={formDisabled ? { opacity: 0 } : { opacity: 1 }}>
                <FormContainer title="Risk Details" show={true}>
                  <FormSection
                    sectionName="RISK_DETAILS"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => handleQuestionChange(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue,
                      questionnaire,
                    )}
                  />

                  {lossPayeeGroup.map((lossPaye, index) => (
                    <FormSection
                      questionnaire={lossPaye}
                      disableAll={isBound}
                      sectionName="RISK_DETAILS_GROUP"
                      sectionIndex={index}
                      values={values}
                      formikRef={formikRef}
                      extraButtons={() => renderAddAndRemoveButtons(lossPayeeGroup, index, lossPaye, setLossPayeeGroup, "$ANSWERS_CO-PERSON-EXG", values)}
                      idOperation={props.match?.params?.idOperation}
                      idOperationParent={props.match?.params?.idOperationParent}
                      idProduct={props.match.params.idProduct}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      ignoreModality
                      permissions={true}
                      onQuestionChange={(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue
                      ) => handleQuestionChange(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue,
                        questionnaire,
                      )}
                    />
                  ))}

                  {feePayableByGroup.map((feeTypeGroup, index) => (
                    <FormSection
                      questionnaire={feeTypeGroup}
                      disableAll={isBound}
                      sectionName="FEE_PAYABLE_BY"
                      sectionIndex={index}
                      values={values}
                      formikRef={formikRef}
                      idOperation={props.match?.params?.idOperation}
                      idOperationParent={props.match?.params?.idOperationParent}
                      idProduct={props.match.params.idProduct}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      ignoreModality
                      permissions={true}
                      onQuestionChange={(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue
                      ) => handleQuestionChange(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue,
                        questionnaire,
                      )}
                    />
                  ))}
                </FormContainer>

                <FormContainer title="Information" show={true}>
                  <FormSection
                    sectionName="INFORMATION"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => handleQuestionChange(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue,
                      questionnaire,
                    )}
                  />
                </FormContainer>

                <FormContainer title="Security Details" show={true}>
                  <FormSection
                    sectionName="SECURITY_DETAILS"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => handleQuestionChange(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue,
                      questionnaire,
                    )}
                  />
                  <FormSection
                    sectionName="PARTYS"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => handleQuestionChange(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue,
                      questionnaire,
                    )}
                  />
                </FormContainer>


                <FormContainer title="Subscription Agreement" show={true}>
                  <FormSection
                    sectionName="SUBSCRIPTON_AGREEMENT"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => handleQuestionChange(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue,
                      questionnaire,
                    )}
                  />
                </FormContainer>

                <FormContainer title="Fiscal and Regulatory" show={true}>
                  <FormSection
                    sectionName="FISCAL_AND_REGULATORY"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => handleQuestionChange(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue,
                      questionnaire,
                    )}
                  />
                </FormContainer>


                <FormContainer title="Broker Remuneration and Deductions" show={true}>
                  <FormSection
                    sectionName="BROKER_REMUNERATION_FEE_CLIENT"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                    idOperation={props.match?.params?.idOperation}
                    idOperationParent={
                      props.match?.params?.idOperationParent
                    }
                    onQuestionChange={(
                      question,
                      value,
                      filteredQuestionnaire,
                      setFilteredQuestionnaire,
                      setFieldValue
                    ) => {
                      if (!value?.idAnswerOption) return;

                      const show = value?.idAnswerOption && value?.idAnswerOption === 1166;
                      setShowBrokerRemuneration(show)

                      let allQuestion = [];
                      for (const group of otherFeesGroup) {
                        allQuestion = [...allQuestion, ...group].map(question => question.idQuestionnaireAnswers).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
                      }

                      setOtherFeesGroup(otherFeesGroup.map(group => {
                        group.map(question => question.behaviorObject.isRequired = show)
                        return group
                      }))

                      if (!show) {
                        setQuestionnaireAnswersToDelete([
                          ...questionnaireAnswersToDelete,
                          ...allQuestion
                        ]);
                      } else {
                        setQuestionnaireAnswersToDelete([
                          ...questionnaireAnswersToDelete.filter(question => !questionnaireAnswersToDelete.includes(question))
                        ]);
                      }
                    }}
                  />
                  <HasPermission permission={showBrokerRemuneration}>
                    {(otherFeesGroup && otherFeesGroup.length > 0) && <Label fontSize={16} style={{ fontWeight: 'bold' }}>Other Fees</Label>}
                    {otherFeesGroup.map((other, index) => (
                      <FormSection
                        disableAll={isBound}
                        sectionName="BROKER_REMUNERATION"
                        sectionIndex={index}
                        questionnaire={other}
                        values={values}
                        formikRef={formikRef}
                        extraButtons={() => renderAddAndRemoveButtons(otherFeesGroup, index, other, setOtherFeesGroup, "$ANSWERS_CO-PERSON-EXG", values)}
                        idOperation={props.match?.params?.idOperation}
                        idOperationParent={props.match?.params?.idOperationParent}
                        idProduct={props.match.params.idProduct}
                        errors={errors}
                        setFieldValue={setFieldValue}
                        setFieldError={setFieldError}
                        permissions={true}
                        onQuestionChange={(
                          question,
                          value,
                          filteredQuestionnaire,
                          setFilteredQuestionnaire,
                          setFieldValue
                        ) => handleQuestionChange(
                          question,
                          value,
                          filteredQuestionnaire,
                          setFilteredQuestionnaire,
                          setFieldValue,
                          questionnaire,
                        )}
                      />
                    ))}
                  </HasPermission>

                  <div style={{ margin: '20px 0px' }}>
                    <FormSection
                      sectionName="BROKER_REMUNERATION_OTHER"
                      questionnaire={questionnaire}
                      values={values}
                      setFieldValue={setFieldValue}
                      formikRef={formikRef}
                      onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                      idOperation={props.match?.params?.idOperation}
                      idOperationParent={
                        props.match?.params?.idOperationParent
                      }
                      onQuestionChange={(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue
                      ) => {
                        if (!value?.idAnswerOption) return;

                        const show = value?.idAnswerOption && value?.idAnswerOption === 6893;
                        setShowBrokerOther(show)

                        let allQuestion = [];
                        for (const group of deductionsGroup) {
                          allQuestion = [...allQuestion, ...group].map(question => question.idQuestionnaireAnswers).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
                        }

                        setDeductionsGroup(deductionsGroup.map(group => {
                          group.map(question => question.behaviorObject.isRequired = show)
                          return group
                        }))

                        if (!show) {
                          setQuestionnaireAnswersToDelete([
                            ...questionnaireAnswersToDelete,
                            ...allQuestion
                          ]);
                        } else {
                          setQuestionnaireAnswersToDelete([
                            ...questionnaireAnswersToDelete.filter(question => !questionnaireAnswersToDelete.includes(question))
                          ]);
                        }
                      }}
                    />

                    <HasPermission permission={showBrokerOther}>
                      {(deductionsGroup && deductionsGroup.length > 0) && <Label fontSize={16} style={{ fontWeight: 'bold' }}>Other Deductions</Label>}
                      {deductionsGroup.map((deductible, index) => (
                        <FormSection
                          disableAll={isBound}
                          sectionName="BROKER_REMUNERATION_DEDUCTION"
                          sectionIndex={index}
                          questionnaire={deductible}
                          values={values}
                          formikRef={formikRef}
                          extraButtons={() => renderAddAndRemoveButtons(deductionsGroup, index, deductible, setDeductionsGroup, "$ANSWERS_BROKER_REMUNERATION_DEDUCTION", values)}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          idProduct={props.match.params.idProduct}
                          errors={errors}
                          setFieldValue={setFieldValue}
                          setFieldError={setFieldError}
                          ignoreModality
                          permissions={true}
                          onQuestionChange={(
                            question,
                            value,
                            filteredQuestionnaire,
                            setFilteredQuestionnaire,
                            setFieldValue
                          ) => handleQuestionChange(
                            question,
                            value,
                            filteredQuestionnaire,
                            setFilteredQuestionnaire,
                            setFieldValue,
                            questionnaire,
                          )}
                        />
                      ))}
                    </HasPermission>
                  </div>
                </FormContainer>

                {(endorsementType && endorsementType === 'declaration') && (
                  <FormContainer title="DECLARATION TEMPLATE " show={true}>
                    <FormSection
                      sectionName="DECLARATION_TEMPLATE"
                      questionnaire={questionnaire}
                      values={values}
                      setFieldValue={setFieldValue}
                      formikRef={formikRef}
                      onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                      idOperation={props.match?.params?.idOperation}
                      idOperationParent={
                        props.match?.params?.idOperationParent
                      }
                      onQuestionChange={(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue
                      ) => handleQuestionChange(
                        question,
                        value,
                        filteredQuestionnaire,
                        setFilteredQuestionnaire,
                        setFieldValue,
                        questionnaire,
                      )}
                    />
                  </FormContainer>
                )}

                <FormSection
                  sectionName="SIGNING"
                  questionnaire={questionnaire}
                  values={values}
                  setFieldValue={setFieldValue}
                  formikRef={formikRef}
                  onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                />


                <ButtonContainer>
                  <Button forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                  <RenderButtons idOperation={props.match?.params?.idOperation}>
                    <ButtonContent>
                      <div style={{ marginTop: "5px" }}>
                        <LostCancelButton idOperation={props.match.params.idOperation} />
                      </div>
                      <Button
                        third
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        name="CDR"
                        id="mktComposition"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}>
                        CDR
                      </Button>
                      <Button
                        primary
                        type="submit"
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        id="btnSave"
                        disabled={isDisable}
                        onClick={() => {
                          validationSchema.current.validate(values).catch((e) => {
                            console.log('validation error', e)
                            mc.error('Please fill in all required fields.')
                          })
                        }}>
                        {endorsementType == 'market-changes' ? 'GENERATE ENDORS. DOC' : 'SAVE AND GENERATE DOCS'}
                      </Button>
                    </ButtonContent>
                  </RenderButtons>
                </ButtonContainer>
              </Form>
            )}
          >
          </Formik>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </>
      </ContentCard>
    </Layout>
  )
}